export default {
  apiKey: 'AIzaSyDdBtTQklyf-mRXpCjrJJ0zJhRUbMDc7DI',
  authDomain: 'grow-with-jo.firebaseapp.com',
  databaseURL: 'https://grow-with-jo.firebaseio.com',
  projectId: 'grow-with-jo',
  storageBucket: 'grow-with-jo.appspot.com',
  messagingSenderId: '493864399545',
  appId: '1:493864399545:web:1ad385e11ec2aeadbce168',
  measurementId: 'G-RZHB5LTXC2',
};
